var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.34847 12.2654L1.83156 10.0915C1.94158 9.59638 2.1905 9.14294 2.54911 8.78432L9.1144 2.21904C10.1558 1.17764 11.8442 1.17764 12.8856 2.21904L13.7811 3.11447C14.8225 4.15587 14.8225 5.8443 13.7811 6.8857L7.21578 13.451C6.85716 13.8096 6.40372 14.0585 5.90864 14.1685L3.7347 14.6516C2.3057 14.9692 1.03091 13.6944 1.34847 12.2654ZM3.13315 10.3807L2.65005 12.5546C2.5442 13.031 2.96913 13.4559 3.44546 13.3501L5.6194 12.867C5.85747 12.8141 6.07628 12.6969 6.25218 12.5285L3.47158 9.74792C3.30319 9.92382 3.18605 10.1426 3.13315 10.3807ZM4.41416 8.80489L7.19521 11.5859L10.9191 7.86208L8.13802 5.08103L4.41416 8.80489ZM12.8383 5.94289L11.8619 6.91927L9.08083 4.13822L10.0572 3.16185C10.5779 2.64115 11.4221 2.64115 11.9428 3.16184L12.8383 4.05728C13.359 4.57797 13.359 5.42219 12.8383 5.94289Z",
    fill: "#FCFCFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/Line.93fade2954d7f8f1c62a38a303ed230c.svg";
export { ForwardRef as ReactComponent };